import { initialState } from './glossari.state';
import * as glossariAction from './glossari.actions';
import { Glossary } from 'src/app/shared/models/glossary.model';
import { Translation } from 'src/app/shared/models/translation.model';
import { SingleFilter } from 'src/app/shared/models/filter-data/single-filter.model';

/**
 * Funzione che gestisce gli aggiornamenti di stato dipendenti dalle azioni sulle pagine di glossari
 * @param state {State} stato a livello dello store glossari, inizialmente valorizzato a initialState
 * @param action {GlossariAction} le azioni disponibili per lo store di glossari
 */
export function glossariReducer(state = initialState, action: glossariAction.GlossariAction) {
    switch (action.type) {
        case glossariAction.GET_LIST_GLOS_SUCCESS: {
            if (action.payload.sezione === glossariAction.tabellaGlossari.main) {
                return {
                    ...state,
                    elencoVociGlossario: state.elencoVociGlossario ? state.elencoVociGlossario.concat(action.payload.elenco.data) : action.payload.elenco.data,
                    elencoFiltriVoci: action.payload.elenco.filter,
                    ordinamentoVoci: action.payload.elenco.orderBy,
                    fromRow: action.payload.elenco.fromRow,
                    toRow: action.payload.elenco.toRow,
                    totalCount: action.payload.elenco.totalCount
                }
            } else if (action.payload.sezione === glossariAction.tabellaGlossari.mainFilterSort) {
                return {
                    ...state,
                    elencoVociGlossario: action.payload.elenco.data,
                    elencoFiltriVoci: action.payload.elenco.filter,
                    ordinamentoVoci: action.payload.elenco.orderBy,
                    fromRow: action.payload.elenco.fromRow,
                    toRow: action.payload.elenco.toRow,
                    totalCount: action.payload.elenco.totalCount
                }
            } else {
                return {
                    ...state,
                    elencoVociGlosModale: action.payload.elenco.data,
                    elencoFiltriVociModale: action.payload.elenco.filter,
                    fromRowModal: action.payload.elenco.fromRow,
                    toRowModal: action.payload.elenco.toRow,
                    totalCountModal: action.payload.elenco.totalCount
                }
            }
        }
        case glossariAction.CLEAN_ON_DESTROY: {
            return {
                ...initialState
            }
        }
        case glossariAction.APPLY_SORT_GLOS: {
            return {
                ...state,
                ordinamentoVoci: action.payload,
                voceSelezionata: null,
                secondarySelections: [],
                fromRow: 0,
                toRow: 50
            }
        }
        case glossariAction.SELECT_GLOSSARY: {
            return {
                ...state,
                voceSelezionata: action.payload,
                secondarySelections: [],
                voceSelezionataAllegato: null
            }
        }
        case glossariAction.UPDATE_GLOSSARY_SUCCESS: {
            let tempElencoVociGlossario = replaceGlossaryInArray(state.elencoVociGlossario, action.payload.nuovoGlos);
            if (state.voceSelezionata && state.voceSelezionata.id === action.payload.nuovoGlos.id) {
                return {
                    ...state,
                    elencoVociGlossario: tempElencoVociGlossario.slice(),
                    voceSelezionata: action.payload.nuovoGlos
                }
            }
            return {
                ...state,
                elencoVociGlossario: tempElencoVociGlossario.slice()
            }
        };
        case glossariAction.UPDATE_MULTIPLE_FIELDS_SUCCESS: {
            let tempElencoVociGlossario = replaceGlossaryInArray(state.elencoVociGlossario, action.payload);
            if (state.voceSelezionata && state.voceSelezionata.id === action.payload.id) {
                return {
                    ...state,
                    elencoVociGlossario: tempElencoVociGlossario.slice(),
                    voceSelezionata: action.payload
                }
            }
            return {
                ...state,
                elencoVociGlossario: tempElencoVociGlossario.slice()
            }
        }
        case glossariAction.GET_TRANSLATIONS_SUCCESS: {
            return {
                ...state,
                riferimentiSelezione: action.payload.slice()
            };
        };
        case glossariAction.GET_SEEALSO_SUCCESS: {
            return {
                ...state,
                vediAncheSelezione: action.payload.slice()
            }
        };
        case glossariAction.APPLY_FILTERS: {
            if (action.payload.sezione === glossariAction.tabellaGlossari.main) {
                return {
                    ...state,
                    elencoFiltriVoci: action.payload.elencoFiltri,
                    voceSelezionata: null,
                    secondarySelections: [],
                    riferimentiSelezione: null,
                    vediAncheSelezione: null,
                    fromRow: 0,
                    toRow: 50
                }
            } else {
                return {
                    ...state,
                    elencoFiltriVociModale: action.payload.elencoFiltri
                }
            }
        };
        case glossariAction.IS_LOADING_TABELLA: {
            if (action.payload.sezione === glossariAction.tabellaGlossari.main || action.payload.sezione === glossariAction.tabellaGlossari.mainFilterSort) {
                return {
                    ...state,
                    isLoadingTabellaVoci: action.payload.valore
                }
            } else {
                return {
                    ...state,
                    isLoadingTabVociModale: action.payload.valore
                }
            }
        };
        case glossariAction.SET_ROW_INTERVAL: {
            if (action.payload.sezione === glossariAction.tabellaGlossari.main) {
                return {
                    ...state,
                    fromRow: action.payload.fromRow,
                    toRow: action.payload.toRow
                }
            } else {
                return {
                    ...state,
                    fromRowModal: action.payload.fromRow,
                    toRowModal: action.payload.toRow
                }
            }
        };
        case glossariAction.DESTROY_MODAL_CERCA_GLOSSARIO: {
            return {
                ...state,
                fromRowModal: null,
                toRowModal: null,
                elencoFiltriVociModale: null,
                elencoVociGlosModale: []
            }
        };
        case glossariAction.SET_SECONDARY_SELECTIONS: {
            return {
                ...state,
                secondarySelections: action.payload
            }
        };
        case glossariAction.ADD_SEEALSO_SUCCESS: {
            let tempSeeAlso = state.vediAncheSelezione.slice();
            if (tempSeeAlso.indexOf(action.payload) === -1) {
                tempSeeAlso.push(action.payload);
            }
            return {
                ...state,
                vediAncheSelezione: tempSeeAlso
            }
        };
        case glossariAction.REMOVE_SEEALSO_SUCCESS: {
            let tempSeeAlso = state.vediAncheSelezione.slice();
            tempSeeAlso = tempSeeAlso.filter(d => {
                return d.id !== action.payload;
            });
            return {
                ...state,
                vediAncheSelezione: tempSeeAlso
            }
        };
        case glossariAction.ADD_NEW_GLOSSARY_SUCCESS: {
            return {
                ...state,
                elencoFiltriVoci: action.payload.filtri,
                voceSelezionata: action.payload.newGlos
            }
        };
        case glossariAction.REMOVE_GLOSSARY_SUCCESS: {
            return {
                ...state,
                elencoVociGlossario: state.elencoVociGlossario.filter(v => v.id !== action.payload)
            }
        };
        case glossariAction.CHANGE_DISPLAY_ADD: {
            return {
                ...state,
                displayAdd: action.payload
            }
        };
        case glossariAction.UPDATE_REFERENCE_TRANSL_SUCCESS: {
            let tempRiferimenti = replaceTranslationInArray(state.riferimentiSelezione, action.payload);
            return {
                ...state,
                riferimentiSelezione: tempRiferimenti
            }
        };
        case glossariAction.DISSOCIATE_GLOS_FROM_GLOS_SECT_SUCCESS: {
            if (action.payload.referenceNumber > 1) {
                if (!action.isIncomeSeeAlsoTransl) {
                    let glosUpdateCount: Glossary = {
                        ...state.voceSelezionata,
                        translationCount: state.voceSelezionata.translationCount - 1
                    };
                    let elencoGlosUpdate = replaceGlossaryInArray(state.elencoVociGlossario, glosUpdateCount);
                    return {
                        ...state,
                        elencoVociGlossario: elencoGlosUpdate,
                        voceSelezionata: glosUpdateCount
                    };
                } else {
                    let glosUpdateCount: Glossary = {
                        ...state.voceSelezionata,
                        seeAlsoIncomeTranslationCount: state.voceSelezionata.seeAlsoIncomeTranslationCount - 1
                    };
                    let elencoGlosUpdate = replaceGlossaryInArray(state.elencoVociGlossario, glosUpdateCount);
                    let elencoIncomeTranslUpdate = state.seeAlsoIncomeTranslationsSelezione.filter(el => el.id !== action.payload.translationId);
                    return {
                        ...state,
                        voceSelezionata: glosUpdateCount,
                        elencoVociGlossario: elencoGlosUpdate,
                        seeAlsoIncomeTranslationsSelezione: elencoIncomeTranslUpdate
                    };
                }
            } else {
                return {
                    ...state,
                    voceSelezionata: null
                };
            }
        };
        case glossariAction.DISSOCIATE_ALL_REFERENCES_SUCCESS: {
            let successMexList = action.payload.dissociationMex.split(' ');
            let canceled = successMexList[2];
            let total = successMexList[4];
            if (canceled === total) {
                return {
                    ...state,
                    voceSelezionata: null
                };
            } else {
                return {
                    ...state
                };
            }
        };
        case glossariAction.GET_REFERENCE_NOTES_SUCCESS: {
            return {
                ...state,
                refDetailsNotes: action.payload ? action.payload.slice() : []
            };
        };
        case glossariAction.GET_REFERENCE_GLOSSARIES_SUCCESS: {
            return {
                ...state,
                refDetailsGlossaries: action.payload ? action.payload.slice() : []
            };
        };
        case glossariAction.CLEAN_REFERENCE_DETAILS: {
            return {
                ...state,
                refDetailsNotes: [],
                refDetailsGlossaries: []
            };
        };
        case glossariAction.GET_GLOS_HISTORY_SUCCESS: {
            return {
                ...state,
                voceSelezionataHistory: action.payload,
                isHistoryDisplayed: true
            };
        };
        case glossariAction.DISPLAY_GLOS_HISTORY: {
            return {
                ...state,
                isHistoryDisplayed: action.payload,
                voceSelezionataHistory: action.payload ? [...state.voceSelezionataHistory] : []
            };
        };
        case glossariAction.GET_SEEALSO_INCOME_TRANSLATIONS_SUCCESS: {
            return {
                ...state,
                seeAlsoIncomeTranslationsSelezione: action.payload
            };
        };
        case glossariAction.GET_GLOSSARY_ATTACHMENT_SUCCESS: {
            return {
                ...state,
                voceSelezionataAllegato: action.payload
            }
        };
        default: {
            return {
                ...state
            }
        }
    }
}

/**
 * Funzione che sostituisce una voce nell'elenco con la sua versione aggiornata
 * @param arrayOriginale {Glossary[]} elenco delle voci di glossario
 * @param glossarioMod {Glossary} voce di glossario modificata
 * @returns {Glossary[]} l'elenco delle voci di glossario aggiornato
 */
function replaceGlossaryInArray(arrayOriginale: Glossary[], glossarioMod: Glossary): Glossary[] {
    let copiaArray = arrayOriginale.slice();
    let index = copiaArray.findIndex(glos => {
        return glos.id === glossarioMod.id;
    });
    copiaArray[index] = <Glossary>{ ...glossarioMod };
    return copiaArray;
}

/**
 * Funzione che sostituisce una traduzione nell'elenco con la sua versione aggiornata
 * @param arrayOriginale {Translation[]} elenco di traduzioni originale
 * @param translMod {Translation} traduzione modificata
 * @returns {Translation[]} l'elenco delle traduzioni aggiornato
 */
function replaceTranslationInArray(arrayOriginale: Translation[], translMod: Translation): Translation[] {
    let copiaArray = arrayOriginale.slice();
    let index = copiaArray.findIndex(transl => {
        return transl.id === translMod.id;
    });
    copiaArray[index] = <Translation>{ ...translMod };
    return copiaArray;
}